import { useNavigate } from "react-router-dom";
import useIsInappWebview from "./useIsInappWebview";
import { sendMessage } from "utils/webview";
import { useSetRecoilState } from "recoil";
import { pcSideTabAtom } from "../recoil/pcSideTabAtom";

export default function useClose() {
  const navigate = useNavigate();
  const isInappWebview = useIsInappWebview();
  const setPCSideTab = useSetRecoilState(pcSideTabAtom);

  const close = () => {
    if (isInappWebview) {
      sendMessage(
        JSON.stringify({
          event: "navigate_back",
        })
      );
    } else {
      setPCSideTab("home");
      navigate("/", { replace: true });
    }
  };
  return close;
}
